<template>
  <vuex-table :fields="fields" table_store="pbx/media/table" style="vertical-align: middle">
    <template slot="description" slot-scope="{ item }">
      <editable-media-name
        :id="item.id"
        :value="item.description"
        :is_edit="item.id === edit_id"
        @on-complete="cancel_edit"
      >
        <template slot="default" slot-scope="{ value }">
          {{ value }}
        </template>
      </editable-media-name>
    </template>

    <template slot="playback" slot-scope="{ item }">
      <player-row :file="item" :hide_name="true" />
    </template>

    <template slot="actions" slot-scope="{ item }">
      <table-dropdown>
        <span class="dropdown-item-icon dropdown-item-icon--edit" @click="start_edit(item.id)">
          {{ $t('shared.component.table.action.rename') }}
        </span>
        <span class="dropdown-item-icon dropdown-item-icon--trash" @click="remove_item(item)">
          {{ $t('shared.component.table.action.delete') }}
        </span>
      </table-dropdown>
    </template>
  </vuex-table>
</template>

<script>
  import EditableMediaName from '@pbx/components/media/_fragments/editable/name';
  import PlayerRow from '@pbx/components/media/_fragments/file-player-row';
  import { MediaModalService } from '@pbx/modals/MediaModalService';
  import { mapActions } from 'vuex';

  export default {
    components: {
      EditableMediaName,
      PlayerRow
    },

    data: () => ({
      edit_id: null
    }),

    computed: {
      fields: function() {
        return [
          {
            key: 'description',
            label: this.$t('shared.component.table.field.name'),
            sortable: true,
            class: 'w-25'
          },
          { key: 'playback', label: this.$t('pbx.media.table.field.play'), sortable: false },
          {
            key: 'created_at',
            label: this.$t('pbx.media.table.field.created_at'),
            sortable: true,
            class: 'w-25 text-center'
          },
          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            sortable: false,
            class: 'text-center'
          }
        ];
      }
    },

    methods: {
      ...mapActions('pbx/media/table', ['getAsyncData']),

      remove_item: function(item) {
        MediaModalService.remove(item.id, item).on('success', () => this.getAsyncData());
      },

      start_edit: function(id) {
        this.edit_id = id;
      },

      cancel_edit: function() {
        this.edit_id = null;
      }
    }
  };
</script>
